import { notifications } from '@mantine/notifications';
import {
  getActivitiesKey,
  getActivityKey,
  useGetActivity,
  useUpdateActivity,
} from 'api-hooks/activity';
import { queryClient } from 'common/repositories/query-client';
import { useRouter } from 'next/router';

import ActivityForm from './components/form';

export default function ActivityView() {
  const { query } = useRouter();
  const id = query?.id as string;
  const queryView = useGetActivity(
    {
      id,
    },
    { enabled: !!id },
  );
  const updateMutation = useUpdateActivity();

  return (
    <ActivityForm
      query={queryView}
      saveMutation={updateMutation}
      onSubmit={async (input) => {
        const result = await updateMutation.mutateAsync({
          body: input,
          activityId: id,
        });

        queryClient.refetchQueries([getActivitiesKey()[0]]);
        queryClient.refetchQueries(getActivityKey({ id: result.data.id }));

        notifications.show({ message: result.message, color: 'green' });

        return result.data;
      }}
    />
  );
}
